import { useEffect, useState } from 'react'
import { fetchHuayJackpotPlayConfig } from '../services/huayJackpotService'

/**
 * แสดงทางเข้าหวยแจ็กพอตเมื่อ platform เปิด + play-config.userEntryVisible
 */
export function useHuayJackpotUserEntry(huayJackpotEnabled?: boolean) {
  const [userEntryVisible, setUserEntryVisible] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    let cancelled = false

    void (async () => {
      if (huayJackpotEnabled !== true) {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
        return
      }

      try {
        const res = await fetchHuayJackpotPlayConfig()
        const open =
          res.data?.userEntryVisible !== false &&
          res.data?.salesOpen === true &&
          Number(res.data?.ticketPrice) > 0
        if (!cancelled) {
          setUserEntryVisible(open)
          setChecked(true)
        }
      } catch {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [huayJackpotEnabled])

  return {
    showHuayJackpotEntry: huayJackpotEnabled === true && userEntryVisible,
    checked,
  }
}
